var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "#199752",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#199752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8611 39.9999C31.7239 39.9995 31.5884 39.9708 31.4628 39.9158C31.3372 39.8607 31.2243 39.7804 31.1311 39.6799L26.2711 34.5099C26.0894 34.3163 25.9921 34.0585 26.0005 33.7931C26.0089 33.5277 26.1225 33.2766 26.3161 33.0949C26.5097 32.9132 26.7675 32.8159 27.0329 32.8244C27.2982 32.8328 27.5494 32.9463 27.7311 33.1399L31.8511 37.5299L40.2611 28.3299C40.3464 28.2236 40.4526 28.1359 40.5731 28.0722C40.6935 28.0084 40.8258 27.97 40.9617 27.9592C41.0975 27.9484 41.2342 27.9655 41.3632 28.0095C41.4922 28.0534 41.6109 28.1233 41.7119 28.2148C41.813 28.3062 41.8943 28.4174 41.9508 28.5415C42.0073 28.6655 42.0378 28.7998 42.0406 28.936C42.0433 29.0723 42.0181 29.2077 41.9666 29.3339C41.9151 29.4601 41.8384 29.5745 41.7411 29.6699L32.6011 39.6699C32.5087 39.7723 32.3962 39.8544 32.2706 39.9112C32.1449 39.968 32.0089 39.9982 31.8711 39.9999H31.8611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.80006cbc4f4461cfd7439a39c496b57e.svg";
export { ForwardRef as ReactComponent };